export var TimeFormatType;
(function (TimeFormatType) {
    TimeFormatType[TimeFormatType["HHMM"] = 0] = "HHMM";
    TimeFormatType[TimeFormatType["HHMMSS"] = 1] = "HHMMSS";
})(TimeFormatType || (TimeFormatType = {}));
